// In-place chain advance URL builder.
//
// Mirrors player-boot's by-id experienceUrl (app/src/player-boot.ts): the next
// experience is fetched from <origin>/publisher/experience/<id>, where <origin>
// is the same host+protocol the current experience was loaded from. We derive
// it from window.pixmoto.experienceMetadata.experienceUrl so the advance always
// hits the same API as the initial load. `meta` override is for tests.

import type { ExperienceMetadataInit } from "@/types/experience";

export function buildExperienceUrlForId(
  idexperience: unknown,
  meta?: ExperienceMetadataInit | null,
): string | null {
  const m: ExperienceMetadataInit =
    meta ||
    (typeof window !== "undefined" &&
      window.pixmoto &&
      window.pixmoto.experienceMetadata) ||
    {};
  if (idexperience == null || !m.experienceUrl) {
    return null;
  }
  try {
    return `${new URL(m.experienceUrl).origin}/publisher/experience/${idexperience}`;
  } catch {
    return null;
  }
}
